module.exports = __webpack_public_path__ + "img/doc.25cd3444.png";